import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Globals } from '../global';
import { environment } from '../../../environments/environment';
import {
  catchError,
  firstValueFrom,
  map,
  Observable,
  of,
  switchMap,
  throwError,
} from 'rxjs';
import { ConfigApi } from '../../config-api';
import { IdleService } from './idle.service';

@Injectable({
  providedIn: 'root',
})
export class ApiCallingService {
  constructor(
    public http: HttpClient,
    private router: Router,
    private messageService: MessageService,
    private globals: Globals,
    private injector: Injector
  ) { }

  getAuthHeader() {
    let token = localStorage.getItem('Auth-token');
    let httpHeaders = new HttpHeaders({
      Accept: 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });
    return httpHeaders;
  }
  getAuthPostHeader() {
    let token = localStorage.getItem('Auth-token');
    let httpHeaders = new HttpHeaders({
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    });
    return httpHeaders;
  }

  callAuthAPI(body: object, type: String, url: string): Observable<any> {
    let token = localStorage.getItem('Auth-user');
    if (!token) {
      this.router.navigate(['/login']);
    }
    let headers: HttpHeaders = this.getAuthHeader();
    let options = {
      headers: headers,
    };
    if (type == 'POST') {
      return this.http.post(url, body, options);
    } else if (type == 'PUT') {
      return this.http.put(url, body, options);
    } else if (type == 'DELETE') {
      return this.http.delete(url, options);
    } else {
      return this.http.get(url, options);
    }
  }
  getIP(): Observable<string> {
    // return this.http.get<any>('https://api.ipify.org/?format=json').pipe(
    //   map(res => res.ipAddress), // depends on provider's format
    //   catchError(() => of('NA'))
    // );
    return of('NA'); // For testing purposes, returning a dummy IP
  }
  callAuthPostAPI(body: object, type: String, url: string): Observable<any> {
    const storedUserData = JSON.parse(localStorage.getItem('Auth-user')!);
    const userId = this.globals.getUserId() || storedUserData.userId;
    const token = this.globals.getToken();
    const loginType = 'Web';
    const description = `IP:N/A, other:${navigator.userAgent}`;
    const publicKey = environment.PublicKey;

    body = { ...body, userId, loginType, description, publicKey };
    const filterUserId = (body as any).filterUserId;
    // if (filterUserId !== undefined) {
    //   // ✅ From getAlertList() — use selected filter user id
    //   (body as any).userId = filterUserId || '';
    //   delete (body as any).filterUserId; // ✅ clean up
    // }

    if (url === ConfigApi.URLS.GET_EMAIL_ALERT_LIST) {

      // ✅ Case 1: came from getAlertList() — filterUserId is present
      const filterUserId = (body as any).filterUserId;
      if (filterUserId !== undefined) {
        (body as any).userId = filterUserId || '';
        delete (body as any).filterUserId; // ✅ clean up
      }

      // ✅ Case 2: came from getEmailAlertUserList() — emptyUserId marker is present
      const emptyUserId = (body as any).emptyUserId;
      if (emptyUserId !== undefined) {
        (body as any).userId = ''; // ✅ empty the userId
        delete (body as any).emptyUserId; // ✅ clean up marker
      }
    }


    if (!token) {
      this.router.navigate(['/login']);
      return of(null); // return dummy observable so chain completes
    }

    const headers: HttpHeaders = this.getAuthPostHeader();
    const options = { headers };

    if (type === 'POST') {
      return this.http.post(url, body, options);
    } else if (type === 'PUT') {
      return this.http.put(url, body, options);
    } else if (type === 'GET') {
      return this.http.get(url, options);
    } else {
      return this.http.delete(url, options);
    }
  }

  callAPI(body: any, type: string, url: string): Observable<any> {
    return this.getIP().pipe(
      switchMap((ip: string) => {

        const description = navigator.userAgent + ' - ' + ip;
        const publicKey = environment.PublicKey;

        let requestBody: any;

        // Handle FormData
        if (body instanceof FormData) {

          body.append('description', description);
          body.append('publicKey', publicKey);

          requestBody = body;

        }
        // Handle normal JSON object
        else {

          requestBody = {
            ...body,
            description,
            publicKey
          };

        }

        const headers = new HttpHeaders();

        switch (type.toUpperCase()) {

          case 'POST':
            return this.http.post(
              url,
              requestBody,
              { headers }
            );

          case 'PUT':
            return this.http.put(
              url,
              requestBody,
              { headers }
            );

          case 'GET':
            return this.http.get(
              url,
              { headers }
            );

          case 'DELETE':
            return this.http.delete(
              url,
              { headers }
            );

          default:
            return this.http.get(
              url,
              { headers }
            );
        }
      }),

      catchError((err) => {
        console.error('Error during API call:', err);
        return throwError(() => err);
      })
    );
  }

  handleSuccess(res: any) {
    if (res.responseCode == 200) {
      return true;
    } else {
      return false;
    }
  }

  logout(payload: any, type: string = 'normal') {
    let msg = 'Log out successfully';
    if (type != 'normal') {
      msg = 'You have been logged out forcefully!';
    }

    this.callAuthPostAPI(payload, 'POST', ConfigApi.URLS.LOGOUT).subscribe(
      (res) => {
        localStorage.clear();
        this.messageService.clear();
        this.messageService.add({ severity: 'success', detail: msg });
        this.router.navigate(['login']);
      },
      (error) => {
        localStorage.clear();
        this.messageService.clear();
        this.messageService.add({ severity: 'success', detail: msg });
        this.router.navigate(['login']);
      }
    );
  }

  showTosterMessage(message: any) {
    const idleService = this.injector.get(IdleService);
    idleService.toastMessageSignal.set({
      severity: message.severity,
      summary: message.summary,
      detail: message.detail,
    });
  }

  passColumnWidth(columnId: any, width: any): void {
    console.log('resize api', columnId, width);
    let payload = {
      userId: this.globals.getUserId(),
      columnWidth: width + 'px',
      columnId: btoa(String(columnId)),
      loginType: '',
    };
    this.callAuthPostAPI(
      payload,
      'POST',
      ConfigApi.URLS.GET_COLUMN_WIDTH
    ).subscribe({
      next: (res: any) => {
        const Data = JSON.parse(res);
        if (this.handleSuccess(Data)) {
          // this.showTosterMessage({
          //   severity: 'success',
          //   summary: 'Success',
          //   detail:
          //     Data.responseMessage.charAt(0).toUpperCase() +
          //     Data.responseMessage.slice(1).toLowerCase(),
          // });
        }
      },
      error: (response) => {
        const err = JSON.parse(response.error);
        this.showTosterMessage({
          severity: 'error',
          summary: 'Error',
          detail:
            err.responseMessage.charAt(0).toUpperCase() +
            err.responseMessage.slice(1).toLowerCase(),
        });
      },
    });
  }
}
